import script from "./BaseChartComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseChartComponent.vue?vue&type=script&setup=true&lang=js"

import "./BaseChartComponent.vue?vue&type=style&index=0&id=2efe5084&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2efe5084"]])

export default __exports__